import styles from "./PageTypeB.module.css";

const PageTypeB = ({title, paragraph1, paragraph2, paragraph3}) => {
  return (
    <main className={styles.main}>
      <div className={styles.wrapper}>
        <h1 className={styles.title}>{title}</h1>
        <div className={styles.textWrapper}>
          <p className={styles.text}>{paragraph1}</p>
          <p className={styles.text}>{paragraph2}</p>
          <p className={styles.text}>{paragraph3}</p>
        </div>
      </div>
    </main>
  );
};

export default PageTypeB;
